// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * Built-in Rust transforms for what is not expressible as data.
 */
export enum TransformId {
  Unspecified = 0,
  FloorOutput = 1,
  CfssFloorOutput = 2,
  FloorLabels = 3,
  ControllerLabels = 4,
  FloorPhysicalOpenings = 5,
  HallCallEligibility = 6,
  JobName = 7,
  DispatcherVersion = 8,
  ControllerVersion = 9,
  ShuttleFloors = 10,
  CarCallSecuritySeed = 11,
  HallCallSecuritySeed = 12,
  Heartbeat = 13,
  HallCallsDisabledEvent = 14,
  HallCallLockCommand = 15,
  CarCallLockCommand = 16,
  ShuttleFloorCommand = 17,
}
